"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDataTypeInstance = void 0;
class ProjectDataTypeInstance {
    get netRefCtx() {
        return this.context.netRefCtx;
    }
    constructor(context) {
        this.context = context;
    }
}
exports.ProjectDataTypeInstance = ProjectDataTypeInstance;
//# sourceMappingURL=ProjectDataTypeInstance.js.map